module.exports = __webpack_public_path__ + "img/1525973371.306340aa.jpg";